export default {
  namespaced: true,
  state: {
    leaves: [],
    leave_credits: [],
    leave_status: [],
    leave_types: [],
    to_approve_leave_request: [],
    overview: [],
    overtime_data: [],
    overtime_to_delete: {},
    to_approve_overtime_data: [],
    overtime_statuses: [],
  },
  mutations: {
    SET_LEAVES(state, payload) {
      state.leaves = [...payload];
    },
    SET_LEAVE_CREDITS(state, payload) {
      state.leave_credits = [...payload];
    },
    SET_LEAVE_STATUS(state, payload) {
      state.leave_status = [...payload];
    },
    SET_LEAVE_TYPES(state, payload) {
      state.leave_types = [...payload];
    },
    SET_TO_APPROVE_LEAVE_REQUEST(state, payload) {
      state.to_approve_leave_request = [...payload];
    },
    SET_OVERVIEW(state, payload) {
      state.overview = [...payload];
    },
    SET_OVERTIME_DATA(state, p) {
      state.overtime_data = [...p];
    },
    SET_OVERTIME_TO_DELETE(state, p) {
      state.overtime_to_delete = p;
    },
    SET_TO_APPROVE_OT_DATA(state, p) {
      state.to_approve_overtime_data = [...p];
    },
    SET_OVERTIME_STATUS(state, p) {
      state.overtime_statuses = [...p];
    },
  },
  getters: {
    getLeaves: (state) => state.leaves,
    getLeaveCredits: (state) => state.leave_credits,
    getLeaveStatus: (state) => state.leave_status,
    getLeaveTypes: (state) => state.leave_types,
    getToApproveLeaveRequest: (state) => state.to_approve_leave_request,
    getOverview: (state) => state.overview,
    getOverTimeData: (state) => state.overtime_data,
    getOverTimeToDelete: (state) => state.overtime_to_delete,
    getToApproveOTData: (state) => state.to_approve_overtime_data,
    getOvertimeStatus: (state) => state.overtime_statuses,
  },
  actions: {
    setLeaves({ commit }, payload) {
      commit("SET_LEAVES", payload);
    },
    setLeaveStatus({ commit }, payload) {
      commit("SET_LEAVE_STATUS", payload);
    },
    setLeaveTypes({ commit }, payload) {
      commit("SET_LEAVE_TYPES", payload);
    },
    setLeaveCredits({ commit }, payload) {
      commit("SET_LEAVE_CREDITS", payload);
    },
    setToApproveLeaveRequest({ commit }, payload) {
      commit("SET_TO_APPROVE_LEAVE_REQUEST", payload);
    },
    setToOverview({ commit }, payload) {
      commit("SET_OVERVIEW", payload);
    },
    setOvertimeData({ commit }, p) {
      commit("SET_OVERTIME_DATA", p);
    },
    setOverTimeToDelete({ commit }, p) {
      commit("SET_OVERTIME_TO_DELETE", p);
    },
    setToApproveOTData({ commit }, p) {
      commit("SET_TO_APPROVE_OT_DATA", p);
    },
    setOvertimeStatus({ commit }, p) {
      commit("SET_OVERTIME_STATUS", p);
    },
  },
};
